import { Link } from "react-router-dom";
import { ClipboardList, HelpCircle, SlidersHorizontal, Layers, FileBarChart, ArrowRight } from "lucide-react";

const CARDS = [
  { to: "/admin/smartinspect/roi-assessments", label: "ROI Assessments", desc: "Create and manage SmartInspect ROI assessments.", icon: ClipboardList, live: true },
  { to: "/admin/smartinspect/questions", label: "Questions", desc: "Configure the ROI assessment questions and steps.", icon: HelpCircle, live: true },
  { to: "#", label: "Assumptions", desc: "Default assumptions for ROI inputs.", icon: SlidersHorizontal, live: false },
  { to: "#", label: "ROI Profiles", desc: "Reusable ROI profiles and benchmarks.", icon: Layers, live: false },
  { to: "#", label: "Reports", desc: "ROI reports and exports.", icon: FileBarChart, live: false },
];

export default function SmartInspectLandingPage() {
  return (
    <div data-testid="smartinspect-landing" className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold text-slate-900">SmartInspect</h1>
      <p className="text-sm text-slate-500 mt-1">Inspection digitisation ROI — assessment configuration and management.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
        {CARDS.map((c) => {
          const Icon = c.icon;
          const body = (
            <div data-testid={`si-card-${c.label.replace(/\s+/g, "-").toLowerCase()}`}
              className={`rounded-xl border p-5 h-full transition ${c.live ? "border-slate-200 bg-white hover:shadow-md hover:border-indigo-300" : "border-dashed border-slate-200 bg-slate-50"}`}>
              <div className="flex items-center justify-between">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600"><Icon size={20} /></div>
                {c.live ? <ArrowRight size={16} className="text-slate-300" /> : <span className="text-[10px] uppercase font-semibold text-amber-600 bg-amber-50 border border-amber-200 rounded-full px-2 py-0.5">Coming Soon</span>}
              </div>
              <div className="mt-3 font-semibold text-slate-800">{c.label}</div>
              <div className="text-sm text-slate-500 mt-1">{c.desc}</div>
            </div>
          );
          return c.live ? <Link key={c.label} to={c.to}>{body}</Link> : <div key={c.label}>{body}</div>;
        })}
      </div>
    </div>
  );
}
